module.exports = __webpack_public_path__ + "img/tohoku-maas-sendai.fd3fdb8f.png";